import { render } from "./form_design.vue?vue&type=template&id=2eb6a6d8&scoped=true"
import script from "./form_design.js?vue&type=script&lang=js"
export * from "./form_design.js?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./form_design.vue?vue&type=style&index=1&id=2eb6a6d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb6a6d8"]])

export default __exports__